import { 
    ACTUALIZAR_LIST_TAREA,
    AGREGAR_TAREA,
  } from "./tareaActions";

  const tareaReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_TAREA: {
            return {
                ...state,
                tareaIDLista: action.payload
            }
        };

        case AGREGAR_TAREA:{
            return {
                 ...state,
                 tareaIDLista: [action.payload, ...state.tareaIDLista]
             }
         };

        default:
            return state;

    }
  }

  export default tareaReducer;